import { render } from "./CustomerDetailSimpleNotesTab.vue?vue&type=template&id=9cb7769e"
import script from "./CustomerDetailSimpleNotesTab.vue?vue&type=script&lang=js"
export * from "./CustomerDetailSimpleNotesTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__